
<div class="viewer-container">
    <div class="zoom-controls flex flex-row space-x-1">
        <img src="assets/icons/icon-zoom-out.svg" (click)="zoomOut()" [ngStyle]="{'opacity' : zoom <= minZoom ? 0.5 : 1}"/>
        <img src="assets/icons/icon-zoom-in.svg" (click)="zoomIn()"/>
    </div>
    <ng-container *ngFor="let number of pageNumbers">
        <canvas #canvas [id]="'pdfCanvas' + number"></canvas>
    </ng-container>
</div>
